import { canAccessSamplePack, SamplePack } from '@arpeggi/shared'
import { useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../../__legacy__/hooks/useAuth'
import { ArpTable } from '../../arp-table'
import { useIsSPEditionHolder } from '../../token-gating/hooks'

export const useSPSamplesSectionContent = (sp: SamplePack) => {
  const { isHolder } = useIsSPEditionHolder(sp)
  const { user } = useAuth()
  const navigate = useNavigate()
  const canViewSamples = canAccessSamplePack(sp, isHolder, user)

  const defaultFilters = useMemo(
    () => ({
      ...ArpTable.DEFAULT_SOUNDS_FILTERS,
      // We want to show blocklisted samples in the sample list.
      // The reason they're blocklisted is so they don't show up on the Explore page.
      isBlocklist: undefined,
      shadowBlocklist: undefined,
      samplePackId: sp.id
    }),
    [sp]
  )

  const handleEmptyStateClick = () => {
    navigate(`/sample-packs/${sp.id}#collect`)
  }

  return {
    canViewSamples,
    handleEmptyStateClick,
    sp,
    defaultFilters
  }
}
